export const CLIPBOARD_ITEM_TYPE_TILE = 'tile';
export const CLIPBOARD_ITEM_TYPE_SECTION = 'section';
export const CLIPBOARD_ITEM_TYPE_SUBPAGE = 'subpage';
export const CLIPBOARD_ITEM_TYPE_TAB = 'tab';
